import { NewAuthTokenResponse } from '@app/core/auth/interfaces/new-access-token-response';
import { ForgotPasswordReqDto } from '@app/pages/auth/forgot-password/interfaces/forgot-password.req.dto';
import { ResetPasswordReqDto } from '@app/pages/auth/reset-password/interfaces/reset-password.req.dto';
import { SignInReqDto } from '@app/pages/auth/sign-in/interfaces/sign-in.req.dto';
import { SignUpReqDto } from '@app/pages/auth/sign-up/interfaces/sign-up.req.dto';
// import { ChangePasswordDto } from '@app/pages/edit-profile/change-pass/change-password.req.dto';

export class SignIn {
  static readonly type = '[Auth] Sign In';
  constructor(public payload: SignInReqDto) {}
}

export class ForgotPassword {
  static readonly type = '[Auth] Forgot Password';
  constructor(public payload: ForgotPasswordReqDto) {}
}

export class ResetPassword {
  static readonly type = '[Auth] Reset Password';
  constructor(public payload: ResetPasswordReqDto) {}
}

export class SignInWithGoogle {
  static readonly type = '[Auth] Sign In With Google';
  constructor(public token: string) {}
}

export class SignUp {
  static readonly type = '[Auth] Sign Up';
  constructor(public payload: SignUpReqDto) {}
}

export class ConfirmSignUp {
  static readonly type = '[Auth] Confirm Sign Up';
  constructor(public token: string) {}
}

// export class ConfirmEmail {
//   static readonly type = '[Auth] Confirm email';
//   constructor(public payload: ConfirmEmailFormData) {}
// }

export class BackendLogout {
  static readonly type = '[Auth] Backend logout';
  constructor(public url: string = '/') {}
}

export class FrontendLogout {
  static readonly type = '[Auth] Frontend logout';
}

export class SaveAuthTokens {
  static readonly type = '[Auth] Save access/refresh tokens';
  constructor(public payload: NewAuthTokenResponse) {}
}

export class ChangePassword {
  static readonly type = '[Auth] Change password';
  // constructor(public payload: ChangePasswordDto) {}
  constructor(public payload: any) {}
}

export class SetReturnUrl {
  static readonly type = '[Auth] Set return url';
  constructor(public url: string | undefined) {}
}
